export default function normaliseId(account) {
    if (!account) return '';
    if (account.partialCardNumber) return account.partialCardNumber;
    const { sortCode, number } = account.accountNumber;
    return `${sortCode}${number}`.replace(/-|\s/g, '');
}
